export default "__VITE_ASSET__DLN3Lnu7__"